module.exports = __webpack_public_path__ + "img/mastercard.e84a59b.png";